<template>
		<div class = "main2">
			<editPsw></editPsw>
			<div class = "login-copyright"> © 2018 zhiyun-tech.com All rights reserved.   桂林智神信息技术有限公司 桂ICP备15010724号-1</div>
		</div>
</template>

<script>
	import sideBar from "@/components/comHtml/sideBar"
	import editPsw from "@/components/loginPage/editPsw"
	export default {
		name: 'test',
		data() {
			return {
			}
		},
		components: {
			sideBar,
			editPsw
		},
		created: function() {
		},
		mounted: function() {
		},
		methods: {
		}

	}
</script>

<style>
@import url("../../static/css/editForm.css");
</style>


// WEBPACK FOOTER //
// src/assets/editPassword.vue